import React, { useState } from "react";
import styles from "./GetSecretCode.module.css";

const GetSecretCode = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [telegram, setTelegram] = useState("");
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setCode("");

    try {
      const response = await fetch("/api/submit-event/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, telegram }),
      });

      const data = await response.json();

      if (response.ok) {
        setCode(data.code);
        setHasSubmitted(true); 
      } else {
        setError(data.error || "Something went wrong.");
      }
    } catch (err) {
      setError("Failed to connect to server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.heading}>
          <img
            src="/images/old_key.png"
            alt="Key"
            style={{ height: "1.25rem", display: "inline", marginRight: "0.5rem", verticalAlign: "middle" }}
          />
          You’ve Deciphered the Secret...
        </h1>
        <p className={styles.subtext}>
          Next Step: Enter your name and email to claim your treasure
        </p>

        <form onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label className={styles.label}>Telegram Username (For verification purposes)</label>
            <input
              type="text"
              placeholder="@mytelegram"
              value={telegram}
              onChange={(e) => setTelegram(e.target.value)}
              className={styles.input}
            />
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.label}>Name</label>
            <input
              type="text"
              placeholder="Input Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.label}>Email</label>
            <input
              type="email"
              placeholder="Input Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.input}
              required
            />
          </div>
          <button type="submit" className={styles.button} disabled={loading || hasSubmitted}>
            {loading ? "Processing..." : (
              <>
                Get Secret Code
                <img
                  src="/images/icons/card_giftcard.svg"
                  alt="Gift Icon"
                  style={{ height: "1rem", marginLeft: "0.5rem", verticalAlign: "middle" }}
                />
              </>
            )}
          </button>
        </form>

        {code && (
          <div className={styles.success}>
            🎉 Here is your secret code!<br/>
            <strong>{code}</strong><br/>
            Now copy this code and go to our IG story Highlight with the title "Event"<br/>
            Go to the last story for the last instruction!
            <div style={{ backgroundColor: 'yellow', marginTop: '8px', fontSize: '14px' }}>
              WARNING: ONLY THE FIRST CLAIM IS VALID !!!!! 
            </div>
          </div>
        )}
        {error && <div className={styles.error}>⚠️{error}</div>}
      </div>
    </div>
  );
};

export default GetSecretCode;